// frontend/src/components/admin/WithdrawalManagement.js
import React, { useEffect, useState } from 'react';
import { Table, Button, Badge, Form, Modal, Spinner, Alert, Tabs, Tab, Row, Col, Card } from 'react-bootstrap';
import api from '../../api';

const WithdrawalManagement = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [status, setStatus] = useState('pending'); // 默认显示待处理的申请
  
  // 处理提现申请的模态框
  const [showProcessModal, setShowProcessModal] = useState(false);
  const [currentWithdrawal, setCurrentWithdrawal] = useState(null);
  const [processingStatus, setProcessingStatus] = useState('');
  const [remarks, setRemarks] = useState('');
  const [processingLoading, setProcessingLoading] = useState(false);
  const [processMessage, setProcessMessage] = useState({ type: '', text: '' });
  
  // 加载提现申请
  const fetchWithdrawals = async (page = 1, withdrawalStatus = status) => {
    setLoading(true);
    try {
      const res = await api.get(`/api/withdrawals?page=${page}&limit=10&status=${withdrawalStatus}`);
      setWithdrawals(res.data.withdrawals || []);
      setCurrentPage(res.data.currentPage || 1);
      setTotalPages(res.data.totalPages || 1);
    } catch (error) {
      console.error('获取提现申请失败:', error);
      alert(error.response?.data?.message || '获取提现申请列表失败');
    } finally {
      setLoading(false);
    }
  };
  
  // 首次加载和状态变化时获取数据
  useEffect(() => {
    fetchWithdrawals(1);
  }, [status]);
  
  // 打开处理提现申请模态框
  const handleShowProcessModal = (withdrawal) => {
    setCurrentWithdrawal(withdrawal);
    setProcessingStatus('');
    setRemarks('');
    setProcessMessage({ type: '', text: '' });
    setShowProcessModal(true);
  };
  
  // 关闭处理提现申请模态框
  const handleCloseProcessModal = () => {
    setShowProcessModal(false);
  };
  
  // 处理提现申请
  const handleProcessWithdrawal = async (e) => {
    e.preventDefault();
    
    if (!processingStatus) {
      setProcessMessage({ type: 'danger', text: '请选择处理结果' });
      return;
    }
    
    setProcessingLoading(true);
    try {
      await api.put(`/api/withdrawals/${currentWithdrawal._id}`, {
        status: processingStatus,
        remarks: remarks
      });
      
      setProcessMessage({ type: 'success', text: '提现申请已处理' });
      
      // 刷新列表
      setTimeout(() => {
        handleCloseProcessModal();
        fetchWithdrawals(currentPage);
      }, 1000);
    } catch (error) {
      setProcessMessage({
        type: 'danger',
        text: error.response?.data?.message || '处理提现申请失败'
      });
    } finally {
      setProcessingLoading(false);
    }
  };
  
  // 获取状态显示文本
  const getStatusText = (status) => {
    switch(status) {
      case 'pending': return '待处理';
      case 'approved': return '已通过';
      case 'rejected': return '已拒绝';
      default: return '未知状态';
    }
  };
  
  // 获取状态对应的样式
  const getStatusVariant = (status) => {
    switch(status) {
      case 'pending': return 'warning';
      case 'approved': return 'success';
      case 'rejected': return 'danger';
      default: return 'secondary';
    }
  };
  
  // 格式化时间显示
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('zh-CN');
  };
  
  return (
    <div style={{ 
      padding: '20px', 
      background: 'linear-gradient(120deg,#f8fcff 60%,#e0f7fa 100%)', 
      minHeight: '100vh' 
    }}>
      <h2 style={{
        color:'#0cf',
        fontWeight:900,
        letterSpacing:2,
        textAlign:'center',
        textShadow:'0 2px 8px #0cf8',
        marginBottom: 30
      }}>
        💳 提现申请管理系统
      </h2>
      
      {/* 状态选择区域 */}
      <div className="mb-4">
        <div style={{
          background: 'rgba(255,255,255,0.95)',
          border: '2px solid #0cf',
          borderRadius: 15,
          padding: 20,
          boxShadow: '0 4px 20px rgba(0,204,255,0.3)'
        }}>
          <div style={{
            background: 'linear-gradient(90deg,#0cf,#0ff)',
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '10px',
            padding: '15px',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            📊 申请状态筛选
          </div>
          
          <Tabs 
            activeKey={status} 
            onSelect={(k) => setStatus(k)} 
            className="custom-tabs"
          >
            <Tab eventKey="pending" title={
              <span style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                ⏳ 待处理
              </span>
            } />
            <Tab eventKey="approved" title={
              <span style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                ✅ 已通过
              </span>
            } />
            <Tab eventKey="rejected" title={
              <span style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                ❌ 已拒绝
              </span>
            } />
            <Tab eventKey="all" title={
              <span style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                📋 全部
              </span>
            } />
          </Tabs>
        </div>
      </div>
      
      {loading ? (
        <div style={{textAlign:'center',marginTop:80}}>
          <Spinner animation="border" variant="info" style={{width:60,height:60}}/>
          <div style={{color:'#0cf',marginTop:16,fontSize:18}}>加载中...</div>
        </div>
      ) : withdrawals.length === 0 ? (
        <div className="text-center" style={{
          background: 'rgba(255,255,255,0.95)',
          borderRadius: 15, 
          padding: 40,
          border: '2px solid #0cf'
        }}>
          <div style={{fontSize: '3rem', marginBottom: '20px'}}>😔</div>
          <h4 style={{color: '#888'}}>暂无{status === 'all' ? '' : getStatusText(status)}提现申请</h4>
          <p style={{color: '#aaa'}}>当前筛选条件下没有找到任何申请记录</p>
        </div>
      ) : (
        <>
          {/* 移动端卡片视图 */}
          <div className="mobile-card-view d-md-none">
            <Row>
              {withdrawals.map((withdrawal) => (
                <Col xs={12} key={withdrawal._id} className="mb-3">
                  <Card style={{
                    borderRadius: 15,
                    border: '2px solid #0cf',
                    boxShadow: '0 4px 20px rgba(0,204,255,0.2)',
                    background: 'linear-gradient(135deg, #fff 0%, #f0f9ff 100%)',
                    overflow: 'hidden'
                  }}>
                    <Card.Header style={{
                      background: 'linear-gradient(135deg, #0cf 0%, #0ff 100%)',
                      color: 'white',
                      fontWeight: 'bold',
                      padding: '15px'
                    }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>💳 #{withdrawal._id.slice(-6)}</span>
                        <Badge bg={getStatusVariant(withdrawal.status)} style={{fontSize: '0.9rem'}}>
                          {getStatusText(withdrawal.status)}
                        </Badge>
                      </div>
                    </Card.Header>
                    <Card.Body style={{padding: '20px'}}>
                      <div className="withdrawal-info">
                        <p><strong>👤 用户:</strong> {withdrawal.userId?.username || '未知用户'}</p>
                        <p><strong>💰 金额:</strong> 
                          <span style={{color: '#e74c3c', fontWeight: 'bold', fontSize: '1.1rem'}}>
                            ¥{withdrawal.amount}
                          </span>
                        </p>
                        <p><strong>📅 申请时间:</strong> {formatDate(withdrawal.createdAt)}</p>
                        {withdrawal.bankInfo && (
                          <div style={{
                            background: 'rgba(0,204,255,0.1)',
                            borderRadius: '8px',
                            padding: '12px',
                            marginTop: '12px'
                          }}>
                            <p style={{fontWeight: 'bold', marginBottom: '8px'}}>🏦 银行信息:</p>
                            <small>
                              <div>{withdrawal.bankInfo.bankName}</div>
                              <div>{withdrawal.bankInfo.cardNumber}</div>
                              <div>{withdrawal.bankInfo.accountName}</div>
                            </small>
                          </div>
                        )}
                        {withdrawal.remarks && (
                          <p><strong>📝 备注:</strong> {withdrawal.remarks}</p>
                        )}
                      </div>
                      {withdrawal.status === 'pending' && (
                        <div className="mt-3">
                          <Button 
                            variant="primary" 
                            size="sm"
                            onClick={() => handleShowProcessModal(withdrawal)}
                            style={{
                              background: 'linear-gradient(90deg,#0cf,#0ff)',
                              border: 'none',
                              borderRadius: 10,
                              fontWeight: 'bold',
                              width: '100%'
                            }}
                          >
                            🔧 立即处理
                          </Button>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          {/* 桌面端表格视图 */}
          <div className="desktop-table-view d-none d-md-block">
            <div style={{
              background: 'rgba(255,255,255,0.95)',
              borderRadius: 15,
              border: '2px solid #0cf',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0,204,255,0.3)'
            }}>
              <Table responsive className="modern-table mb-0">
                <thead style={{
                  background: 'linear-gradient(90deg,#0cf,#0ff)',
                  color: 'white'
                }}>
                  <tr>
                    <th>ID</th>
                    <th>用户名</th>
                    <th>提现金额</th>
                    <th>银行信息</th>
                    <th>申请时间</th>
                    <th>状态</th>
                    <th>处理时间</th>
                    <th>处理人</th>
                    <th>备注</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {withdrawals.map((withdrawal) => (
                    <tr key={withdrawal._id} style={{
                      borderBottom: '1px solid rgba(0,204,255,0.1)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.background = 'rgba(0,204,255,0.05)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.background = 'transparent';
                    }}>
                      <td style={{fontFamily: 'Monaco, monospace', fontWeight: 'bold', color: '#0cf'}}>
                        #{withdrawal._id.slice(-6)}
                      </td>
                      <td style={{fontWeight: '600'}}>{withdrawal.userId?.username || '未知用户'}</td>
                      <td>
                        <span style={{
                          color: '#e74c3c',
                          fontWeight: 'bold',
                          fontSize: '1.1rem'
                        }}>
                          ¥{withdrawal.amount}
                        </span>
                      </td>
                      <td>
                        {withdrawal.bankInfo ? (
                          <div style={{fontSize: '0.85rem'}}>
                            <div><strong>🏦</strong> {withdrawal.bankInfo.bankName}</div>
                            <div><strong>💳</strong> {withdrawal.bankInfo.cardNumber}</div>
                            <div><strong>👤</strong> {withdrawal.bankInfo.accountName}</div>
                          </div>
                        ) : (
                          <span style={{color: '#999'}}>无银行信息</span>
                        )}
                      </td>
                      <td style={{fontSize: '0.9rem'}}>{formatDate(withdrawal.createdAt)}</td>
                      <td>
                        <Badge bg={getStatusVariant(withdrawal.status)} style={{fontSize: '0.85rem'}}>
                          {getStatusText(withdrawal.status)}
                        </Badge>
                      </td>
                      <td style={{fontSize: '0.9rem'}}>{formatDate(withdrawal.reviewedAt)}</td>
                      <td>{withdrawal.reviewerId?.username || '-'}</td>
                      <td style={{maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        {withdrawal.remarks || '-'}
                      </td>
                      <td>
                        {withdrawal.status === 'pending' && (
                          <Button 
                            variant="primary" 
                            size="sm" 
                            onClick={() => handleShowProcessModal(withdrawal)}
                            style={{
                              background: 'linear-gradient(90deg,#0cf,#0ff)',
                              border: 'none',
                              borderRadius: 8,
                              fontWeight: 'bold'
                            }}
                          >
                            🔧 处理
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
          
          {/* 分页控制 */}
          {totalPages > 1 && (
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '30px',
              padding: '20px',
              background: 'rgba(255,255,255,0.95)',
              borderRadius: '15px',
              border: '2px solid #0cf',
              boxShadow: '0 4px 20px rgba(0,204,255,0.2)'
            }}>
              <Button 
                variant="outline-primary" 
                disabled={currentPage <= 1}
                onClick={() => fetchWithdrawals(currentPage - 1)}
                style={{
                  borderRadius: 10,
                  fontWeight: 'bold',
                  borderColor: '#0cf',
                  color: '#0cf'
                }}
              >
                ⟨ 上一页
              </Button>
              <span style={{
                color: '#0cf',
                fontWeight: 'bold',
                fontSize: '1.1rem'
              }}>
                第 {currentPage} 页 / 共 {totalPages} 页
              </span>
              <Button 
                variant="outline-primary" 
                disabled={currentPage >= totalPages}
                onClick={() => fetchWithdrawals(currentPage + 1)}
                style={{
                  borderRadius: 10,
                  fontWeight: 'bold',
                  borderColor: '#0cf',
                  color: '#0cf'
                }}
              >
                下一页 ⟩
              </Button>
            </div>
          )}
        </>
      )}
      
      {/* 处理提现申请的模态框 */}
      <Modal 
        show={showProcessModal} 
        onHide={handleCloseProcessModal}
        size="lg"
        dialogClassName="premium-withdrawal-modal"
        backdrop="static"
        centered
      >
        <Modal.Header className="premium-modal-header" closeButton>
          <Modal.Title className="premium-modal-title">
            <div className="title-content">
              <div className="title-icon">🔧</div>
              <div className="title-text">
                <h4>处理提现申请</h4>
                <span className="application-id">#{currentWithdrawal?._id.slice(-6)}</span>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="premium-modal-body">
          {currentWithdrawal && (
            <>
              {/* 申请详情卡片 */}
              <div className="withdrawal-details-card">
                <div className="detail-header">
                  <span className="detail-icon">📋</span>
                  <span className="detail-title">申请详情</span>
                </div>
                <div className="detail-content">
                  <div className="detail-row">
                    <span className="label">👤 用户名:</span>
                    <span className="value user-name">{currentWithdrawal.userId?.username || '未知用户'}</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">💰 提现金额:</span>
                    <span className="value amount">¥{currentWithdrawal.amount}</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">📅 申请时间:</span>
                    <span className="value time">{formatDate(currentWithdrawal.createdAt)}</span>
                  </div>
                </div>
              </div>
                
              {/* 银行卡信息卡片 */}
              {currentWithdrawal.bankInfo && (
                <div className="bank-info-card">
                  <div className="detail-header">
                    <span className="detail-icon">🏦</span>
                    <span className="detail-title">银行卡信息</span>
                  </div>
                  <div className="bank-content">
                    <div className="bank-row">
                      <span className="bank-label">银行名称:</span>
                      <span className="bank-value">{currentWithdrawal.bankInfo.bankName}</span>
                    </div>
                    <div className="bank-row">
                      <span className="bank-label">卡号:</span>
                      <span className="bank-value card-number">{currentWithdrawal.bankInfo.cardNumber}</span>
                    </div>
                    <div className="bank-row">
                      <span className="bank-label">持卡人:</span>
                      <span className="bank-value">{currentWithdrawal.bankInfo.accountName}</span>
                    </div>
                    <div className="bank-row">
                      <span className="bank-label">开户行:</span>
                      <span className="bank-value">{currentWithdrawal.bankInfo.branchName}</span>
                    </div>
                  </div>
                </div>
              )}
              
              {processMessage.text && (
                <Alert variant={processMessage.type} className="process-alert">
                  <div className="alert-content">
                    <span className="alert-icon">
                      {processMessage.type === 'success' ? '✅' : '❌'}
                    </span>
                    {processMessage.text}
                  </div>
                </Alert>
              )}
              
              {/* 处理表单 */}
              <Form onSubmit={handleProcessWithdrawal} className="process-form">
                <div className="form-section">
                  <div className="section-header">
                    <span className="section-icon">⚖️</span>
                    <span className="section-title">处理结果</span>
                  </div>
                  <div className="radio-group">
                    <label className={`radio-option approved ${processingStatus === 'approved' ? 'selected' : ''}`}>
                      <input
                        type="radio"
                        name="status"
                        value="approved"
                        checked={processingStatus === 'approved'}
                        onChange={() => setProcessingStatus('approved')}
                      />
                      <div className="radio-content">
                        <span className="radio-icon">✅</span>
                        <span className="radio-text">通过申请</span>
                      </div>
                    </label>
                    <label className={`radio-option rejected ${processingStatus === 'rejected' ? 'selected' : ''}`}>
                      <input
                        type="radio"
                        name="status"
                        value="rejected"
                        checked={processingStatus === 'rejected'}
                        onChange={() => setProcessingStatus('rejected')}
                      />
                      <div className="radio-content">
                        <span className="radio-icon">❌</span>
                        <span className="radio-text">拒绝申请</span>
                      </div>
                    </label>
                  </div>
                </div>
                
                <div className="form-section">
                  <div className="section-header">
                    <span className="section-icon">📝</span>
                    <span className="section-title">处理备注</span>
                  </div>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder="请输入处理备注（可选）..."
                    className="remarks-textarea"
                  />
                </div>
              </Form>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="premium-modal-footer">
          <Button 
            variant="outline-secondary" 
            className="cancel-btn"
            onClick={handleCloseProcessModal}
            disabled={processingLoading}
          >
            取消
          </Button>
          <Button 
            variant="primary" 
            className="submit-btn"
            onClick={handleProcessWithdrawal}
            disabled={processingLoading || !processingStatus}
          >
            {processingLoading ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                处理中...
              </>
            ) : (
              <>
                <span className="btn-icon">🔧</span>
                确认处理
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ====== 提现管理系统样式 ====== */}
      <style jsx>{`
        /* ====== 自定义标签页样式 ====== */
        .custom-tabs .nav-link {
          background: rgba(255, 255, 255, 0.1) !important;
          border: 1px solid rgba(0, 204, 255, 0.3) !important;
          color: #0cf !important;
          margin-right: 8px !important;
          border-radius: 8px !important;
          font-weight: 600 !important;
          transition: all 0.3s ease !important;
          padding: 12px 20px !important;
        }

        .custom-tabs .nav-link:hover {
          background: rgba(0, 204, 255, 0.1) !important;
          border-color: #0cf !important;
          transform: translateY(-2px) !important;
        }

        .custom-tabs .nav-link.active {
          background: linear-gradient(90deg, #0cf, #0ff) !important;
          border-color: #0cf !important;
          color: white !important;
        }

        /* ====== 现代表格样式 ====== */
        .modern-table {
          border: none !important;
        }

        .modern-table thead th {
          border: none !important;
          padding: 16px 12px !important;
          font-weight: 700 !important;
          font-size: 0.9rem !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
        }

        .modern-table tbody td {
          border: none !important;
          padding: 16px 12px !important;
          vertical-align: middle !important;
        }

        /* ====== 提现模态框样式 ====== */
        .premium-withdrawal-modal .modal-dialog {
          max-width: 800px !important;
          margin: 20px auto !important;
        }

        .premium-withdrawal-modal .modal-content {
          border: none;
          border-radius: 20px;
          background: linear-gradient(135deg, #1e3a8a 0%, #3730a3 50%, #581c87 100%);
          box-shadow: 
            0 25px 50px rgba(0, 0, 0, 0.6),
            0 0 0 1px rgba(255, 255, 255, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.1);
          overflow: hidden;
          position: relative;
        }

        .premium-withdrawal-modal .modal-content::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: 
            radial-gradient(circle at 20% 20%, rgba(59, 130, 246, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(147, 51, 234, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 40% 70%, rgba(79, 70, 229, 0.05) 0%, transparent 50%);
          pointer-events: none;
          z-index: 1;
        }

        /* ====== 模态框头部样式 ====== */
        .premium-modal-header {
          background: rgba(255, 255, 255, 0.05);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          padding: 24px 32px;
          position: relative;
          z-index: 2;
        }

        .premium-modal-title {
          margin: 0;
          color: white;
        }

        .title-content {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .title-icon {
          font-size: 2rem;
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
        }

        .title-text h4 {
          margin: 0;
          font-size: 1.5rem;
          font-weight: 700;
          background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .application-id {
          font-size: 0.9rem;
          color: rgba(255, 255, 255, 0.7);
          font-weight: 500;
          font-family: 'Monaco', 'Menlo', monospace;
        }

        /* ====== 模态框主体样式 ====== */
        .premium-modal-body {
          padding: 32px;
          position: relative;
          z-index: 2;
          color: white;
          max-height: 70vh;
          overflow-y: auto;
        }

        /* ====== 详情卡片样式 ====== */
        .withdrawal-details-card, .bank-info-card {
          background: rgba(255, 255, 255, 0.08);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 20px;
          margin-bottom: 24px;
          transition: all 0.3s ease;
        }

        .withdrawal-details-card:hover, .bank-info-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
          border-color: rgba(255, 255, 255, 0.2);
        }

        .detail-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
          padding-bottom: 12px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .detail-icon, .section-icon {
          font-size: 1.2rem;
        }

        .detail-title, .section-title {
          font-weight: 600;
          color: rgba(255, 255, 255, 0.9);
          font-size: 1.1rem;
        }

        .detail-content {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .detail-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
        }

        .detail-row .label {
          color: rgba(255, 255, 255, 0.7);
          font-size: 0.9rem;
          font-weight: 500;
          min-width: 120px;
        }

        .detail-row .value {
          font-weight: 600;
          color: white;
          text-align: right;
        }

        .value.user-name {
          color: #60a5fa !important;
        }

        .value.amount {
          color: #f59e0b !important;
          font-size: 1.1rem;
          font-family: 'Monaco', 'Menlo', monospace;
        }

        .value.time {
          color: rgba(255, 255, 255, 0.8) !important;
          font-size: 0.9rem;
        }

        /* ====== 银行信息样式 ====== */
        .bank-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .bank-row {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .bank-label {
          color: rgba(255, 255, 255, 0.7);
          font-size: 0.8rem;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .bank-value {
          color: white;
          font-weight: 600;
        }

        .bank-value.card-number {
          font-family: 'Monaco', 'Menlo', monospace;
          color: #a78bfa !important;
        }

        /* ====== 处理表单样式 ====== */
        .process-form {
          margin-top: 24px;
        }

        .form-section {
          margin-bottom: 24px;
        }

        .section-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
          padding-bottom: 8px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        /* ====== 单选按钮组样式 ====== */
        .radio-group {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .radio-option {
          background: rgba(255, 255, 255, 0.05);
          border: 2px solid rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          padding: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .radio-option input {
          display: none;
        }

        .radio-option:hover {
          border-color: rgba(255, 255, 255, 0.3);
          transform: translateY(-2px);
        }

        .radio-option.selected {
          border-color: #10b981;
          background: rgba(16, 185, 129, 0.1);
        }

        .radio-option.approved.selected {
          border-color: #10b981;
          background: rgba(16, 185, 129, 0.1);
        }

        .radio-option.rejected.selected {
          border-color: #ef4444;
          background: rgba(239, 68, 68, 0.1);
        }

        .radio-content {
          display: flex;
          align-items: center;
          gap: 12px;
          justify-content: center;
        }

        .radio-icon {
          font-size: 1.5rem;
        }

        .radio-text {
          font-weight: 600;
          color: white;
        }

        /* ====== 备注输入框样式 ====== */
        .remarks-textarea {
          background: rgba(255, 255, 255, 0.08) !important;
          border: 1px solid rgba(255, 255, 255, 0.2) !important;
          border-radius: 12px !important;
          color: white !important;
          padding: 16px !important;
          resize: vertical !important;
          font-size: 0.9rem !important;
          line-height: 1.5 !important;
        }

        .remarks-textarea:focus {
          background: rgba(255, 255, 255, 0.12) !important;
          border-color: rgba(59, 130, 246, 0.5) !important;
          box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.25) !important;
        }

        .remarks-textarea::placeholder {
          color: rgba(255, 255, 255, 0.5) !important;
        }

        /* ====== 处理提示样式 ====== */
        .process-alert {
          border: none !important;
          border-radius: 12px !important;
          padding: 16px !important;
          margin-bottom: 24px !important;
        }

        .alert-content {
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 500;
        }

        .alert-icon {
          font-size: 1.2rem;
        }

        /* ====== 模态框底部样式 ====== */
        .premium-modal-footer {
          background: rgba(255, 255, 255, 0.05);
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding: 24px 32px;
          position: relative;
          z-index: 2;
          display: flex;
          justify-content: flex-end;
          gap: 16px;
        }

        .cancel-btn {
          background: rgba(255, 255, 255, 0.1) !important;
          border: 1px solid rgba(255, 255, 255, 0.2) !important;
          color: white !important;
          padding: 12px 24px !important;
          border-radius: 10px !important;
          font-weight: 600 !important;
          transition: all 0.3s ease !important;
        }

        .cancel-btn:hover {
          background: rgba(255, 255, 255, 0.2) !important;
          border-color: rgba(255, 255, 255, 0.3) !important;
          transform: translateY(-2px) !important;
        }

        .submit-btn {
          background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
          border: none !important;
          color: white !important;
          padding: 12px 24px !important;
          border-radius: 10px !important;
          font-weight: 600 !important;
          transition: all 0.3s ease !important;
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
        }

        .submit-btn:hover:not(:disabled) {
          background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
          transform: translateY(-2px) !important;
          box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3) !important;
        }

        .submit-btn:disabled {
          opacity: 0.6 !important;
          cursor: not-allowed !important;
        }

        .btn-icon {
          font-size: 1rem;
        }

        /* ====== 响应式设计 ====== */
        @media (max-width: 768px) {
          .premium-withdrawal-modal .modal-dialog {
            margin: 10px !important;
            max-width: calc(100vw - 20px) !important;
          }

          .premium-modal-header,
          .premium-modal-body,
          .premium-modal-footer {
            padding: 20px;
          }

          .title-content {
            gap: 12px;
          }

          .title-icon {
            font-size: 1.5rem;
          }

          .title-text h4 {
            font-size: 1.2rem;
          }

          .radio-group {
            grid-template-columns: 1fr;
            gap: 12px;
          }

          .bank-content {
            grid-template-columns: 1fr;
            gap: 12px;
          }

          .detail-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
          }

          .detail-row .value {
            text-align: left;
          }

          .premium-modal-footer {
            flex-direction: column;
            gap: 12px;
          }

          .cancel-btn, .submit-btn {
            width: 100% !important;
          }
        }

        @media (max-width: 480px) {
          .premium-modal-header,
          .premium-modal-body,
          .premium-modal-footer {
            padding: 16px;
          }

          .withdrawal-details-card,
          .bank-info-card {
            padding: 16px;
          }

          .radio-option {
            padding: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default WithdrawalManagement;
